/**
 * Beziehungstypen der Kontakt-Herkunft (Kontaktanlage Teil C, #1752) —
 * Spiegel von `apps/api/src/data/herkunftBeziehungstypen.ts`.
 *
 * Die Werte SIND der Speicherwert und müssen zeichengleich zum Backend sein.
 * Bewusst importfrei: `herkunftBezug.ts` importiert `contactToRelationItems.ts`,
 * und das braucht diese Typen auch — eine gemeinsame Datei ohne Abhängigkeiten
 * vermeidet den Zirkelimport.
 *
 * Vorwärts: was der gewählte Kontakt für den neuen ist (Empfehlungsgeber,
 * Tippgeber/Vermittler); rückwärts: was der neue für ihn ist.
 */
export const HERKUNFT_BEZIEHUNGSTYPEN = {
  empfehlungsgeber: "Empfehlungsgeber",
  empfohlen: "Empfohlener Kontakt",
  tippgeber: "Tippgeber/Vermittler",
  vermittelt: "Vermittelter Kontakt",
} as const;

const HERKUNFT_BEZIEHUNGSTYPEN_SET: ReadonlySet<string> = new Set(Object.values(HERKUNFT_BEZIEHUNGSTYPEN));

/**
 * Ist diese Beziehung eine Herkunft-Verknüpfung (T-203)? Geprüft werden Typ UND
 * gespeicherte Gegenrichtung, damit auch Altzeilen mit abweichendem Typ erkannt
 * werden. Herkunft ist keine Beziehung im Netzwerk/Organigramm — sie steht nur
 * im Abschnitt Herkunft und unter „Verknüpfungen".
 */
export function istHerkunftBeziehung(r: { relType?: string | null; reverse?: string | null }): boolean {
  return HERKUNFT_BEZIEHUNGSTYPEN_SET.has(String(r.relType ?? "").trim())
    || HERKUNFT_BEZIEHUNGSTYPEN_SET.has(String(r.reverse ?? "").trim());
}
